export default {
  isWeiXin() {
    // window.navigator.userAgent属性包含了浏览器类型、版本、操作系统类型、浏览器引擎类型等信息，这个属性可以用来判断浏览器类型
    let ua = window.navigator.userAgent.toLowerCase()
    let mic = ua.match(/micromessenger/i)
    console.log(mic)
    // 通过正则表达式匹配ua中是否含有MicroMessenger字符串
    if (mic && mic[0] === 'micromessenger') {
      console.info('微信环境')
      return true
    } else {
      console.info('非微信环境')
      return false
    }
  },
  isAndroidOrIOS() {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
    let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    if (isAndroid) {
      return "android"
    }
    if (isiOS) {
      return "ios"
    }
    return false
  },
  //返回app
  goBack() {
    let edition = localStorage.getItem('edition')
    if (this.isAndroidOrIOS()=== 'ios'&& edition.indexOf('ios') !== -1) {
      console.log('返回')
      //@ts-ignore
      window.webkit.messageHandlers.GoBack.postMessage(null);
    } else if (this.isAndroidOrIOS()=== 'android'&& edition === "Android") {
      //安卓
      //@ts-ignore
      window.pukangbao.goBack();
    }else if (edition=== 'ohos') {
      //安卓
      //@ts-ignore
      window.flutter_inappwebview.callHandler('goBack');
    }
  },
setNavBarHiddenFlutter(hiddenOrShow: number) {
  if (window.flutter_inappwebview != null && window?.flutter_inappwebview?.callHandler != null) {
    try {
      window?.flutter_inappwebview?.callHandler('setNavBarHidden', hiddenOrShow)
    }
    catch (error) {
      console.log(error)
    }
  }
  else {
    console.log('第一遍没加载到callHandler')
    // 延时500ms适配app兼容问题
    setTimeout(() => {
      try {
        window?.flutter_inappwebview?.callHandler('setNavBarHidden', hiddenOrShow)
      }
      catch (error) {
        console.log(error)
      }
    }, 500)
  }
},
  // flutter SetNavTitle 方法
 setSetNavTitleFlutter(title: string) {
  if (window.flutter_inappwebview != null && window?.flutter_inappwebview?.callHandler != null) {
    try {
      window?.flutter_inappwebview?.callHandler('SetNavTitle', title)
    }
    catch (error) {
      console.log(error)
    }
  }
  else {
    console.log('第一遍没加载到callHandler')
    // 延时500ms适配app兼容问题
    setTimeout(() => {
      try {
        window?.flutter_inappwebview?.callHandler('SetNavTitle', title)
      } catch (error) {
        console.log(error)
      }
    }, 500)
  }
},

// 设置导航栏隐藏展示
setNavBarHidden(isShow){
    let edition = localStorage.getItem('edition')
    if (window?.flutter_inappwebview != null) {
      this.setNavBarHiddenFlutter(isShow)
      return
    }
    if (this.isAndroidOrIOS()=== 'ios'&& edition === 'ios') {
      //设置状态栏颜色
      //@ts-ignore
      window.webkit.messageHandlers.SetNavBarHidden.postMessage({hidden: isShow});
    } else if (this.isAndroidOrIOS()=== 'android'&& edition === "Android") {
      //安卓
      //@ts-ignore
      window.pukangbao.setNavBarHidden(isShow)
    }else if (edition=== 'ohos') {
      //鸿蒙
      //@ts-ignore
      window.flutter_inappwebview.callHandler('setNavBarHidden', isShow);
    }
  },
  // 设置标题
setNavTitle(title?: string) {
      const isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
      let edition = isIos ? 'ios' : 'Android'
      if (this.isWeiXin())
        return

      if (window?.flutter_inappwebview != null) {
        if (title) this.setSetNavTitleFlutter(`{"title": "${title}"}`)
        return
      }

      if (edition.includes('ios')) {
        if (window.webkit != null) {
          if (title)
              try {
                  window.webkit?.messageHandlers?.SetNavTitle?.postMessage({ title })
              } catch (error) {
                  console.log(error)
              }
        }
      }
      else if (edition === 'Android' || edition === 'tai_yi_bao') {
        if (window.pukangbao != null) {
          if (title)
              try {
                  window?.pukangbao?.SetNavTitle(JSON.stringify({ title }))
              } catch (error) {
                  console.log(error)
              }
        }
      }
    },

}
